import { JournalId, Pagination } from 'types';

import { parsePaginationDataToTablePaginationData } from 'utils/parsers/table/parsePaginationDataToTablePaginationData';
import { useAppQuery } from '../../../../../../../../../services/reactQuery/useAppQuery';
import StaffHTTPService from '../../../../../../../../../services/HTTPService/staff/StaffHTTPService';

type AutomaticCheckJournalPageNetworkManageProps = {
    journalId: JournalId;
    pagination: Pagination;
};

export const useAutomaticCheckJournalPageNetworkManage = ({
    journalId,
    pagination: { currentPage, currentPageSize, onPaginationValuesChange },
}: AutomaticCheckJournalPageNetworkManageProps) => {
    const {
        data: automaticCheckJournalPayload,
        isInitialLoading: isAutomaticCheckJournalDataInitialLoading,
        isRefetching: isAutomaticCheckJournalDataRefetching,
        isError: isAutomaticCheckJournalDataError,
    } = useAppQuery('AUTOMATIC_CHECK_JOURNALS', [journalId, currentPage, currentPageSize], () =>
        StaffHTTPService.automaticCheckJournal.getAutomaticCheckJournals({
            journalId,
            paginationParams: { size: currentPageSize, page: currentPage },
        }),
    );

    return {
        automaticCheckJournalData: automaticCheckJournalPayload?.content || [],
        isAutomaticCheckJournalDataInitialLoading,
        isAutomaticCheckJournalDataRefetching,
        isAutomaticCheckJournalDataError,
        automaticCheckJournalPagination: {
            ...parsePaginationDataToTablePaginationData({
                currentPage,
                currentPageSize,
            }),
            total: automaticCheckJournalPayload?.totalElements || 0,
            onChange: onPaginationValuesChange,
        },
    };
};
